export default __webpack_public_path__ + "static/media/icon-chevron.8915cee9.svg";